$shm_textarea_code $mol_textarea
	spellcheck false
	View $shm_textarea_code_view
		attr *
			^
			inert \
		text <= value
		row_numb* <= row_numb*
		sidebar_showed <= sidebar_showed
		highlight <= highlight
		syntax <= syntax
